import cx from 'clsx';
import React from 'react';

import { ReactComponent as ClockIcon } from '@assets/svg/ic-clock.svg';
import { ReactComponent as ReminderIcon } from '@assets/svg/ic-reminder.svg';

import useTranslation from '@hooks/useTranslation';

import { getDates } from '../../helpers/getDates';
import type { IDeactivateTable } from '../../model/equipmentsList';
import style from './style.module.scss';

interface IProps {
  deactivateTable?: IDeactivateTable | null;
  isDeactivated: boolean;
  dateFormat: string;
  facilityOffset: number;
}

const DeactivationPeriodColumn: React.FC<IProps> = ({
  deactivateTable,
  isDeactivated,
  dateFormat,
  facilityOffset = 0,
}) => {
  const { t } = useTranslation();

  const { startDate, endDate, remindDate, showScheduledDeactivation } = getDates({
    startDate: deactivateTable?.start_date || null,
    endDate: deactivateTable?.end_date || null,
    remindDate: deactivateTable?.remind_date || null,
    isDeactivated,
    dateFormat,
    facilityOffset,
  });

  return (
    <div className={style.deactivationPeriodWrapper}>
      <div className={cx(style.blockTime, style.firstBlockTime)}>
        <ClockIcon className={style.activationStartDate} />
        <span className={style.ellipsisTextThreeLines}>{startDate}</span>
      </div>
      {showScheduledDeactivation && (
        <div className={style.scheduledDeactivation}>{t('Scheduled deactivation')}</div>
      )}
      <div className={style.blockTime}>
        <ClockIcon className={style.activationEndDate} />
        <span className={style.ellipsisTextThreeLines}>{endDate}</span>
      </div>
      {remindDate && (
        <div className={cx(style.blockTime, style.reminderBlock)}>
          <ReminderIcon className={style.reminderDateIcon} />
          <span className={cx(style.ellipsisTextThreeLines, style.reminderTime)}>{remindDate}</span>
        </div>
      )}
    </div>
  );
};

export default DeactivationPeriodColumn;
